import { useEffect, useState } from "react";
import { Box, Paper, Typography, TextField, Button, Grid } from "@mui/material";
import PaidIcon from "@mui/icons-material/Paid";
import { toast } from "react-toastify";
import { getOtRate, setOtRate } from "../../utils/otRateStorage";
import { fmtRs } from "../../utils/payrollFormat";

const PRIMARY = "#1B5C20";

const OvertimeRateSetup = () => {
  const [savedRate, setSavedRate] = useState(0);
  const [rateInput, setRateInput] = useState("");

  useEffect(() => {
    const current = getOtRate();
    setSavedRate(current);
    setRateInput(current ? String(current) : "");
  }, []);

  const handleSave = () => {
    const value = Number(rateInput);
    if (!rateInput || Number.isNaN(value) || value <= 0) {
      toast.error("Enter a valid OT rate greater than 0.", { autoClose: 2500 });
      return;
    }
    setOtRate(value);
    setSavedRate(value);
    toast.success("OT rate saved. New overtime entries will use this rate.", {
      autoClose: 2500,
    });
  };

  return (
    <Paper elevation={0} sx={{ borderRadius: 3, border: "1px solid #EAEAEA", p: 3, maxWidth: 560 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
        <PaidIcon sx={{ color: PRIMARY }} />
        <Typography variant="h6" fontWeight={700} color={PRIMARY}>
          Overtime Rate
        </Typography>
      </Box>

      <Typography variant="body2" color="#646464" sx={{ mb: 3 }}>
        Set the rate paid per overtime hour. It's saved on this device and is
        pulled in automatically whenever a new Overtime entry is created, so
        it never has to be typed by hand there.
      </Typography>

      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12} sm={7}>
          <TextField
            fullWidth
            type="number"
            label="OT Rate (Rs. per hour)"
            value={rateInput}
            onChange={(e) => setRateInput(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSave}
            sx={{
              height: "56px",
              backgroundColor: PRIMARY,
              textTransform: "none",
              "&:hover": { backgroundColor: "#145016" },
            }}
          >
            Save Rate
          </Button>
        </Grid>
      </Grid>

      <Typography variant="body2" sx={{ mt: 3 }} color="#646464">
        Current saved rate:{" "}
        <Typography component="span" fontWeight={700} color={PRIMARY}>
          {savedRate ? fmtRs(savedRate) : "Not set"}
        </Typography>
      </Typography>
    </Paper>
  );
};

export default OvertimeRateSetup;
